<script>
import { featuredCampaigns } from '../../api/crowdpacs';

export default {
  name: 'CpPopularCampaigns',
  components: {
    CpImagesCarousel: require('../../components/ImagesCarousel').default,
  },
  mounted() {
    this.getFeaturedCampaigns();
  },
  data() {
    return {
      campaigns: [],
    };
  },
  methods: {
    getFeaturedCampaigns() {
      featuredCampaigns()
        .then(response => {
          this.campaigns = response.featured_campaigns;
        })
        .catch(error => {
          console.warn(error);
        });
    },
  },
};
</script>
<template>
  <div v-if="campaigns && campaigns.length" class="campaigns-container">
    <h3 class="subheadline1 black-color">Popular Campaigns on CrowdBlue</h3>
    <CpImagesCarousel :carouselItems="campaigns" />
  </div>
</template>

<style scoped>
.campaigns-container {
  border: 1px solid var(--neutral3);
  border-radius: 8px;
  padding: 16px;
  background-color: var(--white);
}
</style>
